import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface ILimitsAndUsed {
  maxWarehouse: number | null;
  usedWarehouse: number | null;
  maxEmployee: number | null;
  maxComandaUsers: number | null;
  // Adicionales comprados y vigentes; se suman al max* correspondiente.
  additionalUsers: number | null;
  additionalWarehouse: number | null;
  additionalSalebox: number | null;
  additionalComandaUsers: number | null;
  usedSystemUsers: number | null;
  usedComandaUsers: number | null;
  maxSalebox: number | null;
  usedSalebox: number | null;
}

const DEFAULT_STATE = {
  limitsAndUsed: {
    maxWarehouse: null,
    usedWarehouse: null,
    maxEmployee: null,
    maxComandaUsers: null,
    additionalUsers: null,
    additionalWarehouse: null,
    additionalSalebox: null,
    additionalComandaUsers: null,
    usedSystemUsers: null,
    usedComandaUsers: null,
    maxSalebox: null,
    usedSalebox: null,
  },
};

const initialState = DEFAULT_STATE;

export const limitsAndUsedSlice = createSlice({
  name: "limitsAndUsed",
  initialState,
  reducers: {
    updateLimitsAndUsed: (state, action: PayloadAction<ILimitsAndUsed>) => {
      return {
        ...state,
        limitsAndUsed: action.payload,
      };
    },
    incrementSystemUsers: (state) => {
      if (state.limitsAndUsed.usedSystemUsers !== null) {
        state.limitsAndUsed.usedSystemUsers += 1;
      }
    },
    decrementSystemUsers: (state) => {
      if (
        state.limitsAndUsed.usedSystemUsers !== null &&
        state.limitsAndUsed.usedSystemUsers > 0
      ) {
        state.limitsAndUsed.usedSystemUsers -= 1;
      }
    },
    incrementComandaUsers: (state) => {
      if (state.limitsAndUsed.usedComandaUsers !== null) {
        state.limitsAndUsed.usedComandaUsers += 1;
      }
    },
    decrementComandaUsers: (state) => {
      if (
        state.limitsAndUsed.usedComandaUsers !== null &&
        state.limitsAndUsed.usedComandaUsers > 0
      ) {
        state.limitsAndUsed.usedComandaUsers -= 1;
      }
    },
  },
});

export default limitsAndUsedSlice.reducer;
export const {
  updateLimitsAndUsed,
  incrementSystemUsers,
  decrementSystemUsers,
  incrementComandaUsers,
  decrementComandaUsers,
} = limitsAndUsedSlice.actions;
